import { render, staticRenderFns } from "./RekapNilaiList.vue?vue&type=template&id=36fe1910&scoped=true"
import script from "./RekapNilaiList.vue?vue&type=script&lang=js"
export * from "./RekapNilaiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fe1910",
  null
  
)

export default component.exports